"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _GenericFormElement = _interopRequireDefault(require("../GenericFormElement"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Textarea = function Textarea(props) {
  var title = props.title,
      required = props.required,
      description = props.description,
      placeholder = props.placeholder,
      fieldName = props.fieldName,
      validation = props.validation,
      touched = props.touched,
      error = props.error,
      rows = props.rows,
      value = props.value,
      displayRequiredIndicator = props.displayRequiredIndicator,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/_react.default.createElement(_GenericFormElement.default, {
    className: (0, _classnames.default)('Textarea', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: touched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    className: (0, _classnames.default)(className, {
      'error': error && touched
    }),
    id: fieldName,
    name: fieldName,
    component: "textarea",
    value: value,
    placeholder: placeholder,
    rows: rows,
    validate: validation,
    disabled: disabled
  }));
};

var _default = Textarea;
exports.default = _default;